import React from 'react';
import _ from 'underscore';
import classnames from 'classnames';
import { Link, makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    backgroundColor: '#F3F2F1',
    flex: '0 0 33px',
  },
  footerList: {
    display: 'flex',
    paddingLeft: '6px',
  },
  footerLinkContainer: {
    flex: 1,
    listStyle: 'none',
    marginTop: 0,
    marginBottom: 0,
    paddingLeft: 0,
  },
  footerItem: {
    display: 'inline-block',
    padding: '6px 10px',
  },
  footerLink: {
    color: '#106EBE',
  },
  footerButton: {
    color: '#106EBE',
    border: 0,
  },
});

export const PageFooter = () => {
  const links = [
    {
      url: 'https://go.microsoft.com/fwlink/?linkid=2259814',
      text: 'Consumer Healthy Privacy',
    },
  ];
  const classes = useStyles();

  return (
    <div className={classnames(classes.container, 'ba-content-footer')} role="contentinfo">
      <div className={classnames(classes.footerList, 'footer-link-list')}>
        <div className={classnames(classes.footerItem, 'footer-copyright-text')}>
          {`© ${new Date().getFullYear()} Microsoft`}
        </div>
        <ul className={classnames(classes.footerLinkContainer)}>
          {_.map(links, link =>
            (
              <li
                key={link.text}
                className={classnames(classes.footerItem, 'footer-link-item', link.text)}
              >
                <Link
                  className={classes.footerLink}
                  href={link.url}
                  target="_blank"
                >
                  {link.text}
                </Link>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};
